var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link-loading-shadow",class:[{'link-loading-shadow-active':_vm.value}]},[_c('link-loading'),(!!_vm.$slots.default)?_c('div',{staticClass:"link-loading-shadow-slot"},[_vm._t("default")],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }